import React from 'react'
import { Redirect } from 'react-router-dom'
import { css } from 'aphrodite'
import { Col, Row } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../style'

import access from '../../../utils/access'
import SettingsEditor from '../partials/SettingsEditor'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Settings', 'Config')
@observer
export class Settings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: null,
        inputs: {}
      }
    }
  }

  componentWillMount () {
    const _findSettingsLoop = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findSettingsLoop()
        }

        this.props.Settings.getSettings()
      }, 100)
    }

    _findSettingsLoop()
  }

  onInputChange (field, e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        inputs: {
          ...this.state.editor.inputs,
          [e.target.name]: e.target.value
        }
      }
    })
  }

  onFormSubmit (group, e) {
    e.preventDefault()

    Promise.all(
      Object.keys(this.state.editor.inputs).map(key =>
        this.props.Settings.patchSettings(
          `${group}.${key}`,
          this.state.editor.inputs[key]
        )
      )
    ).then(() => {
      this.setState({
        ...this.state,
        editor: {
          inputs: {},
          active: false,
          field: null
        }
      })
    })
  }

  onTRClick (group, name, e) {
    e.preventDefault()

    const _inputs = {}
    _inputs[name] = this.props.Settings.settings[group][name]

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        inputs: _inputs,
        active: !this.state.editor.active,
        group,
        field: name
      }
    })
  }

  render () {
    if (
      !this.props.Auth.token.pending &&
      !this.props.User.me.pending &&
      !access.modSettings(this.props.User.me.permissions || {})
    ) {
      return <Redirect to={`/dashboard/`} />
    }

    if (Object.keys(this.props.Settings.settings).length < 1) {
      return null
    }

    return (
      <Row>
        <Col>
          <Row>
            <Col xs='12' lg='6'>
              <h2 className={css(style.headers.h2)}>Settings</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <SettingsEditor
                settings={this.props.Settings.settings}
                editor={this.state.editor}
                onTRClick={this.onTRClick.bind(this)}
                onInputChange={this.onInputChange.bind(this)}
                onFormSubmit={this.onFormSubmit.bind(this)}
                theme={THEME_LIST[this.props.Config.theme]}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/components/Settings/Main/index.js